import "./Sidebar.css";

export default function Sidebar({
  items = [],
  active,
  onNavigate,
}) {
  const handleClick = (item) => {
    console.log("[SIDEBAR] CLICK:", item.id);
    console.log("[SIDEBAR] PATH:", item.path);

    if (item.path) {
      onNavigate?.(item.path);
    }
  };

  return (
    <aside className="sidebar">
      <nav className="sidebar__nav">
        {items.map((item) => {
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              type="button"
              className={
                active === item.id
                  ? "sidebar__item is-active"
                  : "sidebar__item"
              }
              onClick={() => handleClick(item)}
            >
              <span className="sidebar__icon">
                <Icon />
              </span>

              <span>{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
}